import React, { useEffect, useState } from "react";
import Hero from "../../component/Hero/Hero";
import Footer from "../../component/Footer/Footer";
import BrandsDemo from "../BrandsDemo";
import PromoCarousel from "../../component/PromoCarousel/PromoCarousel";
import "./Home.css";
import ProductGrid from "../../component/Products/ProductGrid";
import DesignationBar from "../../component/DesignationBar/DesignationBar";
import { useLocation } from "react-router-dom";
import PartnersCarousel from "../../component/Partners/PartnersCarousel";
import Reveal from "../../component/ui/Reveal";
import HomeStats from "../../component/ui/HomeStats";

export default function Home() {
  const location = useLocation();
  const [vinResult, setVinResult] = useState(null);

  useEffect(() => {
    if (location.hash === "#products-section") {
      let tries = 0;
      const t = setInterval(() => {
        const el = document.getElementById("products-section");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          clearInterval(t);
        }
        if (++tries > 30) clearInterval(t);
      }, 100);
    }
  }, [location.hash]);

  const handleVinResult = (data) => {
    setVinResult(data || null);
    if (data) {
      // Scroll vers la grille après résultat VIN
      setTimeout(() => {
        const el = document.getElementById("products-section");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  };

  return (
    <div id="page-top">
      <Hero onVinResult={handleVinResult} />
      <Reveal><DesignationBar /></Reveal>

      <Reveal delay={60}><HomeStats /></Reveal>

      <div style={{ marginTop: 24 }}>
        <ProductGrid
          page={3}
          pageSize={100}
          vinResult={vinResult}
          onClearVin={() => setVinResult(null)}
          onError={(e) => console.error(e)}
        />
      </div>

      <Reveal as="div" style={{ margin: "24px 0" }}>
        <div style={{ margin: "24px 0" }}>
          <PromoCarousel intervalMs={6000} />
        </div>
      </Reveal>

      <Reveal delay={80}><BrandsDemo /></Reveal>
      <Reveal delay={120}><PartnersCarousel /></Reveal>
      <div id="footer-section">
        <Footer />
      </div>
    </div>
  );
}
